import React from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import WebsiteRoutes from './routes/WebsiteRoutes';
import AdminRoutes from './routes/AdminRoutes';
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import './index.css';

function App() {
  return (
    <Router>
      <ToastContainer position="top-right"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop
        closeOnClick
        pauseOnHover
        theme="light" />
      <div className="App">
        <WebsiteRoutes />
        <AdminRoutes />
      </div>
    </Router>
  );
}

export default App;